import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useCostTypeLabels = () => {
   const { t } = useTranslation();

   const costTypeLabels: { [key: string]: string } = useMemo(
      () => ({
         RETENTION: t('cost_types.retention'),
         WRONG_RECEIVER: t('cost_types.wrong_receiver'),
         LOST_PALLET: t('cost_types.lost_pallet'),
         DAMAGE: t('pricing.common.damage'),
         INFORMATION_DELAY: t('cost_types.information_delay'),
      }),
      [t],
   );

   return { costTypeLabels };
};
